import { defineBlocksWithJsonArray } from 'blockly/core';

import { beginnerPinField } from '../pins/pin-selector.js';

const SWITCH_BLOCK_STYLE = 'beginner_switch_blocks';

const switchBlockDefinitions = [
  {
    type: 'beginner_switch_when_pressed',
    message0: 'when button pressed on pin %1 %2',
    args0: [
      beginnerPinField('BUTTON_PIN', 'button'),
      { type: 'input_statement', name: 'DO' },
    ],
    previousStatement: null,
    nextStatement: null,
    style: SWITCH_BLOCK_STYLE,
    tooltip: 'Runs the blocks inside when the button is pressed.',
    helpUrl: '',
  },
  {
    type: 'beginner_switch_when_released',
    message0: 'when button released on pin %1 %2',
    args0: [
      beginnerPinField('BUTTON_PIN', 'button'),
      { type: 'input_statement', name: 'DO' },
    ],
    previousStatement: null,
    nextStatement: null,
    style: SWITCH_BLOCK_STYLE,
    tooltip: 'Runs the blocks inside when the button is released.',
    helpUrl: '',
  },
  {
    type: 'beginner_switch_is_pressed',
    message0: 'button pressed on pin %1',
    args0: [beginnerPinField('BUTTON_PIN', 'button')],
    output: 'Boolean',
    style: SWITCH_BLOCK_STYLE,
    tooltip: 'True while the button is pressed.',
    helpUrl: '',
  },
  {
    type: 'beginner_switch_is_released',
    message0: 'is button released on pin %1?',
    args0: [beginnerPinField('BUTTON_PIN', 'button')],
    output: 'Boolean',
    style: SWITCH_BLOCK_STYLE,
    tooltip: 'True while the button is released.',
    helpUrl: '',
  },
  {
    type: 'beginner_switch_wait_pressed',
    message0: 'wait until button pressed on pin %1',
    args0: [beginnerPinField('BUTTON_PIN', 'button')],
    previousStatement: null,
    nextStatement: null,
    style: SWITCH_BLOCK_STYLE,
    tooltip: 'Waits until the button is pressed, then continues.',
    helpUrl: '',
  },
  {
    type: 'beginner_switch_wait_released',
    message0: 'wait until button released on pin %1',
    args0: [beginnerPinField('BUTTON_PIN', 'button')],
    previousStatement: null,
    nextStatement: null,
    style: SWITCH_BLOCK_STYLE,
    tooltip: 'Waits until the button is released, then continues.',
    helpUrl: '',
  },
];

export function registerBeginnerSwitchBlocks(): void {
  defineBlocksWithJsonArray(switchBlockDefinitions);
}
